/* eslint-disable class-methods-use-this */

export default class CprConsentModal {
    get(event) {
        let trackingObject = null;

        switch (event) {
            case 'cpr-consent-modal-shown':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'cpr samtykke',
                    'eventAction': 'Impression',
                    'eventLabel': 'Min side - cpr samtykke pop-up',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'cpr-consent-modal-edit':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'cpr samtykke',
                    'eventAction': 'Rediger',
                    'eventLabel': 'Min side - cpr samtykke pop-up',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'cpr-consent-modal-yes-and-send':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'cpr samtykke',
                    'eventAction': 'Ja - gem ændringer',
                    'eventLabel': 'Min side - cpr samtykke pop-up',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'cpr-consent-modal-no-and-send':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'cpr samtykke',
                    'eventAction': 'Nej - gem ændringer',
                    'eventLabel': 'Min side - cpr samtykke pop-up',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'cpr-consent-modal-no-confirmed':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'cpr samtykke',
                    'eventAction': 'Bekræft nej - bekræft',
                    'eventLabel': 'Min side - cpr samtykke pop-up',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'cpr-consent-modal-no-regret':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'cpr samtykke',
                    'eventAction': 'Annuller',
                    'eventLabel': 'Min side - cpr samtykke pop-up',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
        }
        
        return trackingObject;
    }
}
